import { Link } from "react-router-dom";
import styled from "styled-components";

const UnstyledLink = styled(Link)`
  color: inherit;
  text-decoration: none;
`;

export default UnstyledLink;
